<template>
  <div class="select-date-modal">
    <div class="confirm-booking two">
      <div
        data-w-id="b5d49d2e-d85e-b7da-6a63-080d5b6dc332"
        @click="cancel"
        class="link-block-5 w-inline-block"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="modal-heading">
        <h1 class="modal-heading">Select a Date</h1>
      </div>
      <div class="text-block-57">
        Time zone- <strong>{{ customerInfo.customerTimezone }}</strong
        >&nbsp;
        <a
          href="#"
          data-w-id="99160054-6026-902a-c898-4f489166a091"
          @click="trigger"
          class="link-8"
          ><strong>Update</strong></a
        >
      </div>

      <div class="div-block-83">
        <v-date-picker
          :allowed-dates="allowedDates"
          :no-title="true"
          :full-width="true"
          :color="'#256ff6'"
          :prev-icon="'<'"
          :next-icon="'>'"
          :light="true"
          v-model="date"
          @click:date="click"
        ></v-date-picker>
        <!--        <v-row justify="left">-->
        <!--          <div class="v-picker__body theme&#45;&#45;light" style="width: 290px;">-->
        <!--            <div>-->
        <!--              <div class="v-date-picker-header theme&#45;&#45;light">-->
        <!--                <button type="button" class="v-btn v-btn&#45;&#45;icon v-btn&#45;&#45;round theme&#45;&#45;light v-size&#45;&#45;default" aria-label="Previous month">-->
        <!--                  <span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-left theme&#45;&#45;light"></i></span>-->
        <!--                </button>-->
        <!--                <div class="v-date-picker-header__value">-->
        <!--                  <div class="accent&#45;&#45;text">-->
        <!--                    <button type="button">October 2022</button>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <button type="button" class="v-btn v-btn&#45;&#45;icon v-btn&#45;&#45;round theme&#45;&#45;light v-size&#45;&#45;default" aria-label="Next month">-->
        <!--              <span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-right theme&#45;&#45;light"></i>-->
        <!--              </span>-->
        <!--                </button>-->
        <!--              </div>-->
        <!--              <div class="v-date-picker-table v-date-picker-table&#45;&#45;date theme&#45;&#45;light"><table><thead><tr><th>S</th><th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th></tr></thead><tbody><tr><td></td><td></td><td></td><td></td><td></td><td></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">1</div></button></td></tr><tr><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">2</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">3</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">4</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">5</div></button></td><td><button type="button" class="v-btn v-date-picker-table__current v-btn&#45;&#45;rounded v-btn&#45;&#45;outlined theme&#45;&#45;light accent&#45;&#45;text"><div class="v-btn__content">6</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">7</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">8</div></button></td></tr><tr><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">9</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">10</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">11</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">12</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">13</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">14</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">15</div></button></td></tr><tr><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">16</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">17</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">18</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">19</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">20</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">21</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">22</div></button></td></tr><tr><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">23</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">24</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">25</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">26</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">27</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">28</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">29</div></button></td></tr><tr><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">30</div></button></td><td><button type="button" class="v-btn v-btn&#45;&#45;text v-btn&#45;&#45;rounded theme&#45;&#45;light"><div class="v-btn__content">31</div></button></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div></div></div>-->
        <!--        </v-row>-->
      </div>
    </div>
  </div>
</template>

<script>
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import AvailableTimeRequest from "@/model/requests/AvailableTimeRequest";
import { mapState } from "vuex";

export default {
  name: "SelectDateModal",
  data() {
    return {
      // picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // date: '2022-10-06'
      availableModel: AvailableTimeRequest.readCount,
      datesModel: AvailableTimeRequest.readDates,
      date: ""
    };
  },
  computed: {
    ...mapState({
      singleProfessional: state => state.professional.singleProfessional,
      sessionsCount: state => state.availability.sessionsCount,
      availableDates: state => state.availability.availableDates,
      customerInfo: state => state.customer.customerInfo,
      professionalId: state => state.professional.professionalId
    }),
    availableGroups() {
      return this.sessionsCount.map(data => {
        return {
          // data.availableTimeGroupDate
        };
      });
    }
  },
  props: {
    cancel: Function,
    trigger: Function,
    openTimeGroup: Function
  },
  methods: {
    // allowedDates: val => parseInt(val.split("-")[2], 10) % 2 === 0
    // ["2022-10-04","2022-10-12"]
    // allowedDates: val => this.availableDates.includes(val)
    // allowedDates: val => val === "2022-10-04"
    // allowedDates(val){
    //   if(this.availableGroups.includes(val)){
    //     console.log(this.availableGroups[0]);
    //     console.log(val);
    //     return true;
    //   }
    //   else{
    //     return false;
    //   }
    // }
    allowedDates(val) {
      let dates = this.availableDates;
      if (dates.includes(val)) {
        return true;
      } else {
        return false;
      }
    },
    click(date) {
      // console.log(date);
      // alert(date);
      StoreUtils.commit("availability/setSelectedDateFromModal", date);
      StoreUtils.commit("availability/setSelectedDate", date);
      this.openTimeGroup();
    }
  },
  mounted() {
    // this.availableModel.professionalId = this.singleProfessional.professionalId;
    // StoreUtils.dispatch(
    //   StoreUtils.actions.availability.READ_COUNT,
    //   this.availableModel
    // );
    let professionalId = this.$route.params.id;
    this.datesModel.professionalId = professionalId;
    StoreUtils.dispatch(
      StoreUtils.actions.availability.READ_DATES,
      this.datesModel
    );
  }
};
</script>

<style scoped>
.theme--light.v-card {
  background-color: blue;
  /*display: none;*/
}
.v-picker__title {
  /*display: none;*/
}
</style>
